import { slider } from './slider'
import { offersWidget } from '../offers/main'
require('../../scss/pages/homepage/main.scss');

(function () {
  var FormTabsEngine = require('./form-tabs-engine');
  var PreparePostInit = require('../global/preparePostInitHookFunction');

  var hpFormsOptions = require('./widget-defaults')();

  hpFormsOptions = PreparePostInit(hpFormsOptions, []);

  let affiliatePath = '/.config/hp-forms-affiliates/'

  var hpForms = new FormTabsEngine({
    'form-1': ['airticketFormSmall', hpFormsOptions.letenky],
    'form-2': `${affiliatePath}bookingHpForm`,
    'form-3': `${affiliatePath}rentalCarHpForm`,
    'form-4': ['insuranceForm', hpFormsOptions.pojisteni]
  });

  offersWidget()

  slider()

  // Inicializace prvního formuláře
  hpForms.init('form-1');
})();



// WEBPACK FOOTER //
// ./src/js/homepage/index.js